module.exports = __webpack_public_path__ + "static/media/icPostGoalsNew.8feb92e1.svg";